package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.list

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderLeft
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.rippleEffect
import org.hs_soft.runmynesto.domain.config.transitionColor
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Room
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun RoomItem(
    isSelected: Boolean,
    room: Room?,
    isLastItem: Boolean,
    windowSizeMode: WindowSizeModeEnum,
    onRoomClick: (Room?) -> Unit,
)
{
    val isHovered= remember{ mutableStateOf(false) }


    Row(
        modifier = Modifier
            .position(Position.Relative)
            .rippleEffect {
                onRoomClick(room)
            }
            .cursor(Cursor.Pointer)
            .fillMaxWidth()
            .backgroundColor(
                if (isSelected) Theme.PrimaryStatesSelected.rgb
                else if (isHovered.value) Theme.PrimaryStatesHover.rgb
                else Theme.Transparent.rgb
            )
            .onMouseOver {isHovered.value=true}
            .onMouseLeave { isHovered.value=false }
            .padding(
                left = Dimen.largePadding,
                right = Dimen.normalPadding
            )
            .boxShadow(color = Theme.ActionDisabledBackground.rgb)
            .height(Dimen.checkOutItemHeight),
        verticalAlignment = Alignment.CenterVertically,
    )
    {
        if (!isLastItem)
        {
            Box(
                modifier = Modifier
                    .height(Dimen.checkOutItemHeight)
                    .margin(
                        left =Dimen.semiExtraLargePadding
                    )
            )
            {

                Row(
                    modifier = Modifier
                        .align(Alignment.Center),
                    verticalAlignment = Alignment.CenterVertically,
                )
                {
                    Box(
                        modifier = Modifier
                            .width(Dimen.checkOutNormalLineWidth)
                            .backgroundColor(Theme.TextDisabled.rgb)
                            .height(Dimen.smallThickness)
                    )

                    Box(
                        modifier = Modifier
                            .borderRadius(50.percent)
                            .size(Dimen.smallPadding)
                            .backgroundColor(Theme.TextDisabled.rgb)
                    )



                }


                Box(
                    modifier = Modifier
                        .align(Alignment.TopStart)
                        .height( Dimen.checkOutItemHeight)
                        .backgroundColor(Theme.TextDisabled.rgb)
                        .width(Dimen.smallThickness)
                )



            }
        }else {
            Box(
                modifier = Modifier
                    .height(Dimen.checkOutItemHeight)
                    .margin(
                        left = Dimen.semiExtraLargePadding
                    )
            ) {
                Box(
                    modifier = Modifier
                        .align(Alignment.TopStart)
                        .height((Dimen.checkOutItemHeight.value.toInt()/2).px)
                        .width(Dimen.checkOutNormalLineWidth)
                        .borderRadius(
                            bottomLeft = Dimen.smallBorderRadius
                        )
                        .borderLeft(
                            width = Dimen.smallThickness,
                            color = Theme.TextDisabled.rgb,
                            style = LineStyle.Solid,
                        )
                        .borderBottom(
                            width = Dimen.smallThickness,
                            color = Theme.TextDisabled.rgb,
                            style = LineStyle.Solid,
                        )
                )

                Box(
                    modifier = Modifier
                        .align(Alignment.CenterEnd)
                        .margin(
                            top = (-(Dimen.extraExtraSmallPadding.value.toInt())).px,
                            left =Dimen.checkOutNormalLineWidth
                        )
                        .borderRadius(50.percent)
                        .size(Dimen.smallPadding)
                        .backgroundColor(Theme.TextDisabled.rgb)
                )
            }
        }


        SpanText(
            text = room?.caption?:"",
            modifier = Modifier
                .margin(left = Dimen.semiNormalPadding)
                .fontWeight(FontWeight.Normal)
                .fontFamily(FontFamily.Jakarta)
                .fontSize(FontSizes.mediumFontSize)
                .transitionColor()
                .color(  Theme.TextPrimary.rgb),
        )



    }
}